import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const StartupJourneySectionEn = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/en/startup-journey');
  };

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-blue-50 animate-on-scroll relative">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Startup Journey
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Different types of startups face unique challenges and follow distinct paths to success. Whether you're building AI solutions, transforming traditional industries, or developing cutting-edge deeptech, understanding these differences is crucial for your growth journey.
            </p>

            <p
              className="text-lg text-gray-700 mb-8 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: 'The startup journey typically progresses through five key stages: <strong>Idea</strong> (conceptualization and validation), <strong>Starting Up</strong> (building the foundation and early development), <strong>Accelerating</strong> (scaling operations and market growth), <strong>Global Expansion</strong> (international market entry and growth), and finally <strong>Exit or Maturity</strong> (strategic exits or becoming an established market player).' }}
            />

            <Button
              variant="cyan"
              size="lg"
              onClick={handleLearnMore}
              className="px-12 py-6 text-xl font-bold rounded-full"
            >
              Read more about the Startup Journey
              <ArrowRight className="ml-3 h-6 w-6" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartupJourneySectionEn;
